import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import AuthActionShell, { authButtonClass, authInputClass } from "@/components/AuthActionShell";

export default function ForgotPasswordPage() {
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState((searchParams.get("email") || "").trim().toLowerCase());
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const submit = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setMessage(data.message);
    } catch {
      setMessage("If an account exists for that email, a password reset link has been sent.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthActionShell
      eyebrow="Account recovery"
      title="Reset your password"
      description="Enter your Callsect email. If an account exists, we will send a one-time reset link."
    >
      {message ? (
        <div className="auth-action-status is-success" role="status">
          <CheckCircle size={19} weight="fill" />
          <span>{message}</span>
        </div>
      ) : (
        <form onSubmit={submit} className="auth-action-form">
          <label className="auth-action-label">
            Email
            <input
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
              autoComplete="email"
              className={authInputClass}
              placeholder="you@company.com"
            />
          </label>
          <button type="submit" disabled={loading} className={authButtonClass}>
            {loading ? "Sending..." : "Send reset link"}
          </button>
        </form>
      )}
      <Link to="/login" className="auth-action-text-link">
        Back to sign in →
      </Link>
    </AuthActionShell>
  );
}
